import { z } from 'zod';
import { BUCKET_TYPES } from '@fortem-monorepo/constants';
export const createBucketSchema = z.object({
    bucket_name: z.string().min(1),
    bucket_type: z.enum(BUCKET_TYPES),
});
export const deleteBucketSchema = z.object({
    bucket_id: z.string(),
});
